import moment from 'moment'
import { IFacilityInfo, IFacilityAppointment, IShipperTrackingSegment } from 'types/shipment'
import { capitalize } from 'utils/capitalize'
import { FORMATS } from 'constants/datetime'

export const formatCityState = (facility?: IFacilityInfo) => {
  const city = capitalize(facility?.city)
  const state = facility?.stateCode
  return city && state ? `${city}, ${state}` : undefined
}

export const formatStartAtDate = (appointment?: IFacilityAppointment) =>
  appointment && moment(appointment.startAtDate).format(FORMATS.dayFormat)

export const formatTrackingSegment = (
  shipperTrackingSegment?: Partial<IShipperTrackingSegment>
) => {
  if (!shipperTrackingSegment) return undefined

  const { description, level } = shipperTrackingSegment
  return {
    title: `Level ${level}: ${description}`,
    ...shipperTrackingSegment,
  }
}
